import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface SportbackSelectedIconProps {
  color?: Color;
}

const SportbackSelectedIcon: React.FC<SportbackSelectedIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_44901)">
      <path
        d="M8.78008 30.17C8.78008 30.17 5.36006 29.85 4.63006 29.74C3.90006 29.63 2.63012 29.54 2.44012 27.74C2.25012 25.94 2.35006 22.81 3.76006 21.74C5.2532 20.6131 6.95147 19.7878 8.76006 19.31C10.5001 18.84 18.5301 17.37 22.7601 17.48C25.9777 15.5151 29.3179 13.7582 32.7601 12.22C34.2101 11.75 40.0701 10.8 53.1401 11.88C55.0501 12.21 71.7501 16.88 72.1401 17.11C72.5327 17.5979 72.814 18.1658 72.9643 18.7738C73.1146 19.3818 73.1301 20.0153 73.0101 20.63C73.1001 21.72 73.11 22.63 73.11 22.63L73.3301 23.91C73.3301 23.91 73.2401 27.37 71.9301 27.66C70.1801 28.04 66.2401 28.32 65.3801 28.41L8.78008 30.17Z"
        fill={color}
        stroke={color}
        strokeWidth="0.75"
      />
      <path
        d="M11.5 20.77C10.76 20.77 9.18 20.87 8.67 20.95C8 21.06 6.87995 21.4 6.73995 21.79C6.58731 22.2719 6.6086 22.7921 6.8 23.26C7.71253 23.3629 8.63503 23.336 9.53999 23.18C10.3308 22.4748 11.0725 21.7163 11.76 20.91C11.78 20.86 11.78 20.76 11.5 20.77Z"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M25.4401 18.21C25.4401 18.21 37.55 17.73 42.35 17.65L63.88 17.35"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M43.3499 13.08L42.5699 17.78"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.1899 14.79L58.7499 17.35"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M23.73 28.57L52.77 27.71" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M73.46 19.06H69.2299C69.1858 19.0648 69.1437 19.0808 69.1075 19.1065C69.0713 19.1323 69.0423 19.1668 69.0233 19.2069C69.0042 19.247 68.9957 19.2913 68.9986 19.3356C69.0015 19.3799 69.0158 19.4228 69.04 19.46C69.27 19.82 69.59 20.32 69.76 20.52C69.93 20.72 70.5 21.52 71.08 21.6C71.66 21.68 73.27 21.6 73.27 21.6H73.46"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M22.02 27.33V27.56C22.02 28.9188 21.4809 30.2222 20.521 31.1839C19.5611 32.1457 18.2589 32.6874 16.9 32.69C16.2263 32.69 15.5593 32.5573 14.9369 32.2995C14.3145 32.0417 13.7489 31.6638 13.2726 31.1875C12.7962 30.7111 12.4183 30.1456 12.1605 29.5232C11.9027 28.9008 11.77 28.2337 11.77 27.56C11.7727 26.2012 12.3143 24.8989 13.2761 23.939C14.2379 22.9791 15.5412 22.44 16.9 22.44C18.0678 22.438 19.2009 22.8369 20.11 23.57"
        fill={color}
      />
      <path
        d="M22.02 27.33V27.56C22.02 28.9188 21.4809 30.2222 20.521 31.1839C19.5611 32.1457 18.2589 32.6874 16.9 32.69C16.2263 32.69 15.5593 32.5573 14.9369 32.2995C14.3145 32.0417 13.7489 31.6638 13.2726 31.1875C12.7962 30.7111 12.4183 30.1456 12.1605 29.5232C11.9027 28.9008 11.77 28.2337 11.77 27.56C11.7727 26.2012 12.3143 24.8989 13.2761 23.939C14.2379 22.9791 15.5412 22.44 16.9 22.44C18.0678 22.438 19.2009 22.8369 20.11 23.57"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M64.72 27.33C64.725 27.4066 64.725 27.4834 64.72 27.56C64.72 28.9188 64.181 30.2221 63.2211 31.1839C62.2612 32.1457 60.9588 32.6873 59.6 32.69C58.2394 32.69 56.9346 32.1495 55.9725 31.1874C55.0105 30.2254 54.47 28.9205 54.47 27.56C54.47 26.8868 54.6028 26.2202 54.8607 25.5983C55.1186 24.9765 55.4966 24.4116 55.9731 23.9361C56.4496 23.4605 57.0152 23.0836 57.6376 22.8268C58.2599 22.5701 58.9268 22.4387 59.6 22.44C60.7678 22.438 61.901 22.8369 62.8101 23.57"
        fill={color}
      />
      <path
        d="M64.72 27.33C64.725 27.4066 64.725 27.4834 64.72 27.56C64.72 28.9188 64.181 30.2221 63.2211 31.1839C62.2612 32.1457 60.9588 32.6873 59.6 32.69C58.2394 32.69 56.9346 32.1495 55.9725 31.1874C55.0105 30.2254 54.47 28.9205 54.47 27.56C54.47 26.8868 54.6028 26.2202 54.8607 25.5983C55.1186 24.9765 55.4966 24.4116 55.9731 23.9361C56.4496 23.4605 57.0152 23.0836 57.6376 22.8268C58.2599 22.5701 58.9268 22.4387 59.6 22.44C60.7678 22.438 61.901 22.8369 62.8101 23.57"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_44901">
        <rect width="71.65" height="22.1" fill="white" transform="translate(2 11)" />
      </clipPath>
    </defs>
  </svg>
);

export default SportbackSelectedIcon;
